jQuery(function ($) {
    // Use global shared function from main.js if available, otherwise fallback to local
    const loadValidationScript = window.loadValidationScript || function (callback) {
        if (window.InputValidator) {
            if (typeof callback === 'function') callback();
        } else if (window._validationScriptLoading) {
            const checkInterval = setInterval(function () {
                if (window.InputValidator) {
                    clearInterval(checkInterval);
                    delete window._validationScriptLoading;
                    if (typeof callback === 'function') callback();
                }
            }, 50);
        } else {
            window._validationScriptLoading = true;
            $.getScript("/assets/frontend/js/validation.js", function () {
                delete window._validationScriptLoading;
                if (typeof callback === 'function') callback();
            });
        }
    };

    loadValidationScript(function () {
        // Leasing v2 has a dedicated script (`center-modal-form-v2.js`).
        // Skip legacy handler on pages where v2 modal is present to avoid double submit handling.
        if ($('.center-form-modal-v2').length > 0 || $('#center-modal-form[data-form-version="v2"]').length > 0) {
            return;
        }

        const centerModalFormParent = $("body");
        const centerModalForm = $(".center-modal-form");
        const centerModalFormPreloader = $(".center-modal-form-preloader");
        const warningBoxCenterModalForm = $(".center-modal-form-warning-messages");

        // CENTER FORM MODAL SELECTIZE
        $('.center-form-modal-selectize').selectize({
            plugins: ["clear_on_focus"],
            onChange: function () {
                $(this.$input[0]).removeClass('input-warning');
                $(this.$input[0]).siblings('.warning-message').hide();
            }
        });
        // END CENTER FORM MODAL SELECTIZE

        function normalizePhoneInput(value) {
            return String(value || '').replace(/\s+/g, '');
        }

        function getApplicantType($form) {
            const radioValue = String($form.find('input[name="applicant_type"]:checked').val() || '').toLowerCase();
            if (radioValue === 'company') return 'company';
            if (radioValue === 'person') return 'person';
            const hiddenValue = String($form.find('input[name="applicant_type"]').val() || '').toLowerCase();
            return hiddenValue === 'company' ? 'company' : 'person';
        }

        function mapErrorFieldForApplicantType(field, applicantType) {
            if (applicantType !== 'company') {
                return field;
            }
            if (field === 'name') return 'company_representative_name';
            if (field === 'email') return 'company_representative_email';
            if (field === 'phone') return 'company_representative_phone';
            return field;
        }

        function syncApplicantTypeCards($form) {
            const applicantType = getApplicantType($form);
            $form.find('.center-modal-applicant-type-card').removeClass('is-active');
            $form.find('.center-modal-applicant-type-card[data-applicant-card="' + applicantType + '"]').addClass('is-active');
        }

        function toggleApplicantFields($form) {
            const isCompany = getApplicantType($form) === 'company';
            const personFields = $form.find('.center-modal-form-person-fields');
            const companyFields = $form.find('.center-modal-form-company-fields');

            personFields.toggleClass('d-none', isCompany).toggleClass('d-flex', !isCompany);
            companyFields.toggleClass('d-none', !isCompany).toggleClass('d-flex', isCompany);
            syncApplicantTypeCards($form);

            // Disable hidden field groups so serializeArray only includes active flow fields.
            personFields.find(':input').prop('disabled', isCompany);
            companyFields.find(':input').prop('disabled', !isCompany);
        }

        function clearWarningState($form) {
            warningBoxCenterModalForm.hide();
            Object.values(formFields).forEach(function (field) {
                field.input.find('input, select, textarea').removeClass('input-warning');
                field.message.hide();
            });
            $form.find('input, select, textarea').removeClass('input-warning');
        }

        function markFieldError($form, fieldName, message, applicantType) {
            const mappedFieldName = mapErrorFieldForApplicantType(fieldName, applicantType);
            const fieldConfig = formFields[mappedFieldName];

            if (fieldConfig) {
                const inputElement = fieldConfig.input.find('input, select, textarea');
                if (inputElement.length > 0) {
                    inputElement.addClass('input-warning');
                } else {
                    const fallbackByMappedName = $form.find('[name="' + mappedFieldName + '"]');
                    if (fallbackByMappedName.length > 0) {
                        fallbackByMappedName.addClass('input-warning');
                    }
                }

                if (fieldConfig.message && fieldConfig.message.length > 0) {
                    fieldConfig.message.text(message).show();
                }
                return;
            }

            const fallbackInput = $form.find('[name="' + mappedFieldName + '"], [name="' + fieldName + '"]');
            if (fallbackInput.length > 0) {
                fallbackInput.addClass('input-warning');
            }
        }

        // Personal Code Input Handling
        const personalCodeInput = $('#personal-code-input');
        personalCodeInput.on('input', function (e) {
            let value = e.target.value.replace(/[^0-9]/g, '');
            if (value.length > 6) {
                value = value.slice(0, 6) + '-' + value.slice(6);
            }
            e.target.value = value.slice(0, 12);
        });

        // Phone input: remove whitespace automatically (fixes "+371 26 707 277" etc)
        centerModalFormParent.on('input', '.center-modal-form input[name="phone"], .center-modal-form input[name="company_representative_phone"]', function (e) {
            const normalized = normalizePhoneInput(e.target.value);
            if (e.target.value !== normalized) {
                e.target.value = normalized;
            }
        });

        // Input and message elements
        const formFields = {
            name: {
                input: $(".center-modal-form-input-warning-name"),
                message: $(".center-modal-form-message-warning-name")
            },
            surname: {
                input: $(".center-modal-form-input-warning-surname"),
                message: $(".center-modal-form-message-warning-surname")
            },
            code: {
                input: $(".center-modal-form-input-warning-code"),
                message: $(".center-modal-form-message-warning-code")
            },
            email: {
                input: $(".center-modal-form-input-warning-email"),
                message: $(".center-modal-form-message-warning-email")
            },
            phone: {
                input: $(".center-modal-form-input-warning-phone"),
                message: $(".center-modal-form-message-warning-phone")
            },
            income: {
                input: $(".center-modal-form-input-warning-income"),
                message: $(".center-modal-form-message-warning-income")
            },
            workplace: {
                input: $(".center-modal-form-input-warning-workplace"),
                message: $(".center-modal-form-message-warning-workplace")
            },
            work_experience: {
                input: $(".center-modal-form-input-warning-work-experience"),
                message: $(".center-modal-form-message-warning-work-experience")
            },
            channel: {
                input: $(".center-modal-form-input-warning-channel"),
                message: $(".center-modal-form-message-warning-channel")
            },
            company_name: {
                input: $(".center-modal-form-input-warning-company-name"),
                message: $(".center-modal-form-message-warning-company-name")
            },
            company_registration_number: {
                input: $(".center-modal-form-input-warning-company-registration-number"),
                message: $(".center-modal-form-message-warning-company-registration-number")
            },
            company_representative_name: {
                input: $(".center-modal-form-input-warning-company-representative-name"),
                message: $(".center-modal-form-message-warning-company-representative-name")
            },
            company_representative_surname: {
                input: $(".center-modal-form-input-warning-company-representative-surname"),
                message: $(".center-modal-form-message-warning-company-representative-surname")
            },
            company_representative_phone: {
                input: $(".center-modal-form-input-warning-company-representative-phone"),
                message: $(".center-modal-form-message-warning-company-representative-phone")
            },
            company_representative_email: {
                input: $(".center-modal-form-input-warning-company-representative-email"),
                message: $(".center-modal-form-message-warning-company-representative-email")
            },
            privacy_policy: {
                input: $(".center-modal-form-input-warning-privacy-policy"),
                message: $(".center-modal-form-message-warning-privacy-policy")
            }
        };

        let centerModalFormRunner = true;

        // Initialize applicant field visibility
        centerModalForm.each(function () {
            toggleApplicantFields($(this));
        });

        centerModalFormParent.on('change', '.center-modal-form input[name="applicant_type"]', function () {
            const form = $(this).closest('form');
            toggleApplicantFields(form);
            clearWarningState(form);
        });

        centerModalFormParent.on("submit", ".center-modal-form", function (e) {
            e.preventDefault();

            if (centerModalFormRunner !== true) {
                return;
            }

            centerModalFormRunner = false;

            const form = $(e.target);
            const applicantType = getApplicantType(form);
            const submitUrl = applicantType === 'company' ? "/leasing/submit-company-email" : "/leasing/submitStep1";

            let formData = form.serializeArray().reduce(function (obj, item) {
                const csrfName = window.CSRFHelper && window.CSRFHelper.getCSRFData ? window.CSRFHelper.getCSRFData().name : 'carbuy_csrf';
                if (item.name === csrfName || item.name === 'csrf_test_name' || item.name === 'csrf_hash' || item.name === 'csrf_name') {
                    return obj;
                }
                obj[item.name] = item.value;
                return obj;
            }, {});

            if (applicantType === 'company') {
                const representativeName = String(formData.company_representative_name || '').trim();
                const representativeEmail = String(formData.company_representative_email || '').trim();
                const representativePhone = normalizePhoneInput(formData.company_representative_phone || '');

                formData.applicant_type = 'company';
                formData.name = representativeName;
                formData.email = representativeEmail;
                formData.phone = representativePhone;
                formData.company_representative_phone = representativePhone;

                delete formData.surname;
                delete formData.code;
                delete formData.income;
                delete formData.workplace;
                delete formData.work_experience;
            } else {
                formData.applicant_type = 'person';
                if (typeof formData.phone === 'string') {
                    formData.phone = normalizePhoneInput(formData.phone);
                }
                if (!Object.prototype.hasOwnProperty.call(formData, 'work_experience')) {
                    formData.work_experience = form.find('input[name="work_experience"]').val() || '';
                }
            }

            // Capture calculator values (total_price and term) from calculator inputs
            // First try to get from hidden inputs in the form (set when modal opens)
            let calculatorTotalPrice = form.find('input[name="calculator_total_price"]').val();
            let calculatorTerm = form.find('input[name="calculator_term"]').val();

            // Fallback: get from calculator inputs on the page (if still accessible)
            if (!calculatorTotalPrice) {
                const calculatorPrice = $('#calculator-price');
                if (calculatorPrice.length && calculatorPrice.attr('data-int-value')) {
                    calculatorTotalPrice = calculatorPrice.attr('data-int-value');
                }
            }

            if (!calculatorTerm) {
                const calculatorTermInput = $('#calculator-term');
                if (calculatorTermInput.length && calculatorTermInput.attr('data-int-value')) {
                    calculatorTerm = calculatorTermInput.attr('data-int-value');
                }
            }

            if (calculatorTotalPrice) {
                formData.total_price = calculatorTotalPrice;
            }
            if (calculatorTerm) {
                formData.term = calculatorTerm;
            }

            function buildLeasingModalTrackPayload(response, applicantTypeValue) {
                const modalCtx = window.CarBuyLeasingModalContext || {};
                const pricing = {
                    loan_amount: calculatorTotalPrice || formData.total_price || modalCtx.loan_amount || '',
                    total_price: calculatorTotalPrice || formData.total_price || modalCtx.loan_amount || '',
                    vehicle_price: modalCtx.vehicle_price || ''
                };
                if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.buildLeasingPricingFromExtra === 'function') {
                    Object.assign(pricing, window.CarBuyMetaPixel.buildLeasingPricingFromExtra(Object.assign({
                        car_id: formData.car_id || modalCtx.car_id || ''
                    }, pricing)));
                }
                return Object.assign({
                    applicant_type: applicantTypeValue,
                    car_id: formData.car_id || modalCtx.car_id || '',
                    form_location: 'leasing_modal',
                    application_ref: response.application_ref || '',
                    application_id: response.application_id || 0
                }, pricing);
            }

            centerModalFormPreloader.addClass("preloader-visible");
            clearWarningState(form);

            csrfSafeAjaxPost(
                submitUrl,
                formData,
                function (response) {
                    if (response.success) {
                        const trackPayload = buildLeasingModalTrackPayload(response, applicantType);
                        const trackDone = function () { /* analytics best-effort */ };
                        if (applicantType === 'company') {
                            if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.trackLeasingCompleteConversion === 'function') {
                                window.CarBuyAnalytics.trackLeasingCompleteConversion(trackPayload, trackDone);
                            }
                        } else if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.trackLeasingStep1Conversion === 'function') {
                            window.CarBuyAnalytics.trackLeasingStep1Conversion(trackPayload, trackDone);
                        }

                        $(".center-form-modal-main-inner").remove();
                        const successBox = $(".center-form-modal-success-submit");
                        if (applicantType === 'company') {
                            const companySuccessText = String(form.data('companySuccessText') || '').trim();
                            if (companySuccessText !== '') {
                                successBox.find(".center-form-modal-success-subtext").text(companySuccessText);
                            }
                            successBox.removeClass("d-none");
                            return;
                        }

                        successBox.removeClass("d-none");
                        setTimeout(function () {
                            window.location.href = response.redirect || '/leasing/complete-app';
                        }, 2000);
                        return;
                    }

                    if (response.errors) {
                        warningBoxCenterModalForm.show();
                        Object.entries(response.errors).forEach(function (entry) {
                            markFieldError(form, entry[0], entry[1], applicantType);
                        });
                    } else if (response.message) {
                        warningBoxCenterModalForm.show().html('<div class="single-warning-message">' + $('<div>').text(response.message).html() + '</div>');
                    }
                },
                function (xhr, status, error) {
                    centerModalFormRunner = true;
                    centerModalFormPreloader.removeClass("preloader-visible");

                    console.error('Leasing form submission error:', {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        error: error,
                        responseText: xhr.responseText
                    });

                    if (xhr.status === 403) {
                        warningBoxCenterModalForm.show().html('<div class="single-warning-message">Sesijas laiks beidzies. Lūdzu pārlādējiet lapu un mēģiniet vēlreiz.</div>');
                        return;
                    }

                    try {
                        if (!xhr.responseText) {
                            warningBoxCenterModalForm.show().html('<div class="single-warning-message">Kļūda savienojumā. Lūdzu mēģiniet vēlreiz.</div>');
                            return;
                        }

                        const response = JSON.parse(xhr.responseText);

                        if (response.csrf_hash && response.csrf_name) {
                            window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
                        }

                        if (response.errors) {
                            warningBoxCenterModalForm.show();
                            Object.entries(response.errors).forEach(function (entry) {
                                markFieldError(form, entry[0], entry[1], applicantType);
                            });
                        } else if (response.message) {
                            warningBoxCenterModalForm.show().html('<div class="single-warning-message">' + $('<div>').text(response.message).html() + '</div>');
                        } else {
                            warningBoxCenterModalForm.show().html('<div class="single-warning-message">Kļūda nosūtot pieteikumu. Lūdzu mēģiniet vēlreiz.</div>');
                        }
                    } catch (parseError) {
                        console.error('Failed to parse error response:', parseError);
                        warningBoxCenterModalForm.show().html('<div class="single-warning-message">Kļūda apstrādājot atbildi. Lūdzu mēģiniet vēlreiz.</div>');
                    }
                },
                function () {
                    centerModalFormRunner = true;
                    centerModalFormPreloader.removeClass("preloader-visible");
                }
            );
        });

        // Reset validation on input change
        Object.entries(formFields).forEach(function (entry) {
            const fieldName = entry[0];
            const field = entry[1];
            const inputElements = field.input.find('input, select, textarea');

            if (inputElements.length > 0) {
                inputElements.on('input change', function () {
                    $(this).removeClass('input-warning');
                    if (field.message && field.message.length > 0) {
                        field.message.hide();
                    }
                    if (warningBoxCenterModalForm.is(':visible') && !$('.center-modal-form .input-warning').length) {
                        warningBoxCenterModalForm.hide();
                    }
                });
                return;
            }

            centerModalForm.on('input change', '[name="' + fieldName + '"]', function () {
                $(this).removeClass('input-warning');
                if (field.message && field.message.length > 0) {
                    field.message.hide();
                }
                if (warningBoxCenterModalForm.is(':visible') && !$('.center-modal-form .input-warning').length) {
                    warningBoxCenterModalForm.hide();
                }
            });
        });
    });
});